import React from 'react';
import { Camera } from 'lucide-react';

const GallerySection = () => {
  const galleryImages = [
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/qcc0dwxh_IMG_3853.jpeg',
      title: 'Interior Detail - Dodge Charger',
      category: 'Interior'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/jffkm8hh_IMG_3640.jpeg',
      title: 'Exterior Detail - Chrysler 300',
      category: 'Exterior'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/ghk7a3dh_IMG_3328.jpeg',
      title: 'Interior Detail - Premium Finish',
      category: 'Interior'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/jrnqf3do_IMG_3227.jpeg',
      title: 'Interior Detail - RAV4',
      category: 'Interior'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/olznrjbp_IMG_3532.jpeg',
      title: 'Wheel & Fender Detail',
      category: 'Detail Work'
    },
    {
      url: 'https://customer-assets.emergentagent.com/job_showroom-shine-3/artifacts/q0xu1dmc_IMG_3642.jpeg',
      title: 'Full Exterior - Chrysler 300',
      category: 'Exterior'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-black">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-yellow-500/20 to-amber-400/20 border border-yellow-500/30 mb-6">
            <Camera className="w-5 h-5 text-yellow-400" />
            <span className="text-yellow-400 font-semibold">Our Work</span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            Results That <span className="text-transparent bg-clip-text bg-gradient-to-r from-yellow-500 to-amber-400">Speak for Themselves</span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Real photos from real customers - see the quality of our professional detailing work
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {galleryImages.map((image, index) => (
            <div 
              key={index}
              className="group relative aspect-square rounded-xl overflow-hidden border-2 border-yellow-500/20 hover:border-yellow-500 transition-all duration-300 cursor-pointer"
            >
              <img 
                src={image.url}
                alt={image.title}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
              />
              
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <div className="inline-block px-3 py-1 rounded-full bg-gradient-to-r from-yellow-500 to-amber-400 text-black text-xs font-bold mb-2">
                    {image.category}
                  </div>
                  <h3 className="text-white font-bold text-lg">{image.title}</h3>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Call to Action */}
        <div className="text-center mt-12">
          <p className="text-gray-400 mb-4">
            Want your vehicle to look this good?
          </p>
          <button 
            onClick={() => document.getElementById('booking-section')?.scrollIntoView({ behavior: 'smooth' })}
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-yellow-500 to-amber-400 hover:from-yellow-600 hover:to-amber-500 text-black font-bold rounded-lg transition-all duration-300 hover:scale-105 shadow-lg shadow-yellow-500/30"
          >
            Book Your Detail Now
          </button>
        </div>
      </div>
    </section>
  );
};

export default GallerySection;
